import Placeholder from 'components/Placeholder';
import type { SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

type Props = SitecoreBlockProps;

export default function MediaCaption({ params, rendering }: Props) {
	return (
		<div id={params?.anchor} className={getEditorMargin(params)}>
			<Placeholder name="jula-media-caption" rendering={rendering} />
		</div>
	);
}
MediaCaption.displayName = 'MediaCaption';
